import { Navigate, useParams } from 'react-router-dom'

/** Old QR target `/:store/register` now feeds the unified wizard at the company step. */
export function EmployeeRegisterRedirect() {
  const { store } = useParams()
  return <Navigate to={`/signup?role=employee&store=${encodeURIComponent(store || '')}&step=1`} replace />
}

/** Old employer entry `/store/create`. */
export function StoreCreateRedirect() {
  return <Navigate to="/signup?role=employer" replace />
}

/** Old group-admin entry `/group/create`. */
export function GroupCreateRedirect() {
  return <Navigate to="/signup?role=employer&group=1" replace />
}
